import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { productFormSchema } from '../types'
import type { ProductFormData } from '../types'

interface ProductFormProps {
  onSubmit: (data: ProductFormData) => void
  isSubmitting: boolean
  error?: string | null
}

export function ProductForm({
  onSubmit,
  isSubmitting,
  error,
}: ProductFormProps) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ProductFormData>({
    resolver: zodResolver(productFormSchema),
    defaultValues: {
      name: '',
      sku: '',
      points: 0,
    },
  })

  const handleFormSubmit = (data: ProductFormData) => {
    onSubmit(data)
    reset()
  }

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
          {error}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre del producto *
          </label>
          <input {...register('name')} className="input" />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            SKU *
          </label>
          <input {...register('sku')} className="input" />
          {errors.sku && (
            <p className="text-red-500 text-sm mt-1">{errors.sku.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Puntos *
          </label>
          <input
            {...register('points', { valueAsNumber: true })}
            type="number"
            className="input"
          />
          {errors.points && (
            <p className="text-red-500 text-sm mt-1">{errors.points.message}</p>
          )}
        </div>
      </div>

      <button type="submit" disabled={isSubmitting} className="btn btn-primary">
        {isSubmitting ? 'Guardando...' : 'Agregar Producto'}
      </button>
    </form>
  )
}
